export default function (minute) {
    var hours = Math.floor(minute / 60)
    var minutes = minute % 60

    return [hours, minutes, 0]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "00" || i > 0)
        .join(":")
}
